import { render, staticRenderFns } from "./VStudentSearchField.vue?vue&type=template&id=62c2d682&"
import script from "./VStudentSearchField.vue?vue&type=script&lang=js&"
export * from "./VStudentSearchField.vue?vue&type=script&lang=js&"
import style0 from "./VStudentSearchField.vue?vue&type=style&index=0&id=62c2d682&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports